import React, { useState, useEffect } from "react";
import { ReactSVG } from "react-svg";
import BuildingIcon from "../../assets/images/Building.svg";
import Clock from "../../assets/images/clock.svg";
import BOA from "../../assets/images/Boa.svg";
import Freezing from "../../assets/images/Freezing.svg";
import Unfreezing from "../../assets/images/Unfreezing.svg";
import Bars from "../../assets/images/bars.svg";
import Calendar from "../../assets/images/calendar.svg";
import Setting from "../../assets/images/setting.svg";
import { withTranslation } from "react-i18next";
import { Link, withRouter } from "react-router-dom";

const SideBar = (props) => {
  const { t } = props;
  const [activeTab, setActiveTab] = useState("");
  // Function to redirect to specific page and get selected tab is param
  useEffect(() => {
    setActiveTab(props.location.pathname.slice(1));
  }, [props.location.pathname]);

  return (
    // Sidebar menu list section
    <aside className="Sidebar ">
      <ul className="sidebarList list-unstyled cardBg">
        <li className={activeTab.includes("overview") ? "active" : ""}>
          <Link to="/overview">
            <ReactSVG src={BuildingIcon} />
            <span>{t("Overview")}</span>
          </Link>
        </li>
        <li
          className={activeTab.includes("transactions-history") ? "active" : ""}
        >
          <Link to="/transactions-history">
            <ReactSVG src={Clock} />
            <span>{t("Transaction_History")}</span>
          </Link>
        </li>
        <li className={activeTab.includes("send-boa") ? "active" : ""}>
          <Link to="/send-boa">
            <ReactSVG src={BOA} />
            <span>{t("Send_BOA")}</span>
          </Link>
        </li>
        <li className={activeTab.includes("create-validator") ? "active" : ""}>
          <Link to="/create-validator">
            <ReactSVG src={Freezing} />
            <span>{t("Create_Validator")}</span>
          </Link>
        </li>
        <li className={activeTab.includes("unfreezing") ? "active" : ""}>
          <Link to="/unfreezing">
            <ReactSVG src={Unfreezing} />
            <span>{t("Unfreezing")}</span>
          </Link>
        </li>
        <li className={activeTab.includes("store-data") ? "active" : ""}>
          <Link to="/store-data">
            <ReactSVG src={Bars} />
            <span>{t("Store_Data")}</span>
          </Link>
        </li>
        <li className={activeTab.includes("contact-list") ? "active" : ""}>
          <Link to="/contact-list">
            <ReactSVG src={Calendar} />
            <span>{t("Contact_List")}</span>
          </Link>
        </li>
        <li className={activeTab.includes("settings") ? "active" : ""}>
          <Link to="/settings">
            <ReactSVG src={Setting} />
            <span>{t("Settings")}</span>
          </Link>
        </li>
      </ul>
    </aside>
  );
};

export default withTranslation()(withRouter(React.memo(SideBar)));
